"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const megamenu_1 = __importDefault(require("./Actions/megamenu"));
const siteSettings_1 = __importDefault(require("./Actions/siteSettings"));
const translations_1 = __importDefault(require("./Actions/translations"));
const cart_1 = __importDefault(require("./Actions/cart"));
const header_1 = __importDefault(require("./Actions/header"));
const footer_1 = __importDefault(require("./Actions/footer"));
const user_1 = __importDefault(require("./Actions/user"));
const initData_1 = __importDefault(require("./Actions/initData"));
const serviceCenterLinks_1 = __importDefault(require("./Actions/serviceCenterLinks"));
const errorPages_1 = __importDefault(require("./Actions/errorPages"));
const loginModal_1 = __importDefault(require("./Actions/loginModal"));
const favoriteShiptosModal_1 = __importDefault(require("./Actions/favoriteShiptosModal"));
const content_1 = __importDefault(require("./Actions/content"));
const dialogModal_1 = __importDefault(require("./Actions/dialogModal"));
exports.store = (0, toolkit_1.configureStore)({
    reducer: {
        menuToggle: megamenu_1.default,
        siteSettings: siteSettings_1.default,
        translations: translations_1.default,
        cart: cart_1.default,
        header: header_1.default,
        footer: footer_1.default,
        user: user_1.default,
        serviceCenterLinks: serviceCenterLinks_1.default,
        initialData: initData_1.default,
        errorPages: errorPages_1.default,
        loginModal: loginModal_1.default,
        favoriteShiptosModal: favoriteShiptosModal_1.default,
        content: content_1.default,
        dialogModal: dialogModal_1.default
    }
});
